import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import Box from 'components/Box';
import Text from 'components/Text';
import Flex from 'components/Flex';
import TeamPickerModal from 'screens/TeamPickerModal';
import AdvancedAudienceWidget from 'components/AdvancedAudienceWidget';
import Stack from 'components/Stack';
import SimpleModal from 'components/SimpleModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ShareWithTeamsWidget(_ref) {
  var disabled = _ref.disabled,
    teamsToInclude = _ref.teamsToInclude,
    teamsToExclude = _ref.teamsToExclude,
    onChangeTeamsToInclude = _ref.onChangeTeamsToInclude,
    onChangeTeamsToExclude = _ref.onChangeTeamsToExclude;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    teamGroupIndex = _useState2[0],
    setTeamGroupIndex = _useState2[1];
  var showTeamSelectorModal = teamGroupIndex !== null;
  var closeTeamSelector = function closeTeamSelector() {
    return setTeamGroupIndex(null);
  };
  var initialTeamSelectorSelection = teamGroupIndex === -1 || teamGroupIndex === null ? teamsToExclude : teamsToInclude[teamGroupIndex];
  var disabledTeams = teamGroupIndex === -1 ? teamsToInclude === null || teamsToInclude === void 0 ? void 0 : teamsToInclude.flat() : teamsToExclude;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showDisableAdvancedModal = _useState4[0],
    setShowDisableAdvancedModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isAdvancedMode = _useState6[0],
    setAdvancedMode = _useState6[1];
  function onToggleAdvancedMode() {
    if (isAdvancedMode && (teamsToInclude.length > 1 || teamsToExclude.length)) {
      setShowDisableAdvancedModal(true);
    } else if (isAdvancedMode && teamsToInclude.length <= 1 && !teamsToExclude.length) {
      setAdvancedMode(false);
    } else {
      setAdvancedMode(true);
    }
  }
  function disableAdvancedMode() {
    setAdvancedMode(false);
    var firstGrouping = teamsToInclude[0] || [];
    onChangeTeamsToInclude([firstGrouping]);
    onChangeTeamsToExclude([]);
    setShowDisableAdvancedModal(false);
  }
  function removeTeamFromGroup(id, teamGroupIndex) {
    if (teamGroupIndex === -1) {
      onChangeTeamsToExclude(teamsToExclude.filter(function (team) {
        return team.id !== id;
      }));
    } else {
      var filteredSubArray = teamsToInclude[teamGroupIndex].filter(function (team) {
        return team.id !== id;
      });
      var teamsToIncludeCopy = _toConsumableArray(teamsToInclude);
      if (filteredSubArray.length > 0) {
        teamsToIncludeCopy.splice(teamGroupIndex, 1, filteredSubArray);
      } else {
        teamsToIncludeCopy.splice(teamGroupIndex, 1);
      }
      onChangeTeamsToInclude(teamsToIncludeCopy);
    }
  }
  function changeSelectedTeams(_x) {
    return _changeSelectedTeams.apply(this, arguments);
  }
  function _changeSelectedTeams() {
    _changeSelectedTeams = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var toAdd, toRemove, diff, uniqueDiff, teamsToIncludeCopy, _diff, _diff2, _uniqueDiff;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            toAdd = _ref2.toAdd, toRemove = _ref2.toRemove;
            if (teamGroupIndex !== -1 && teamGroupIndex !== null) {
              if (teamsToInclude[teamGroupIndex]) {
                diff = [].concat(_toConsumableArray(teamsToInclude[teamGroupIndex]), _toConsumableArray(toAdd)).filter(function (added) {
                  return !toRemove.some(function (removed) {
                    return added.id === removed.id;
                  });
                });
                uniqueDiff = _toConsumableArray(new Set(diff));
                teamsToIncludeCopy = _toConsumableArray(teamsToInclude);
                teamsToIncludeCopy.splice(teamGroupIndex, 1, uniqueDiff);
                onChangeTeamsToInclude(teamsToIncludeCopy);
              } else {
                _diff = toAdd.filter(function (added) {
                  return !toRemove.some(function (removed) {
                    return added.id === removed.id;
                  });
                });
                onChangeTeamsToInclude([].concat(_toConsumableArray(teamsToInclude), [_diff]));
              }
            } else {
              _diff2 = [].concat(_toConsumableArray(teamsToExclude), _toConsumableArray(toAdd)).filter(function (added) {
                return !toRemove.some(function (removed) {
                  return added.id === removed.id;
                });
              });
              _uniqueDiff = _toConsumableArray(new Set(_diff2));
              onChangeTeamsToExclude(_uniqueDiff);
            }
            closeTeamSelector();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _changeSelectedTeams.apply(this, arguments);
  }
  var hasTeamsToIncludeSelected = (teamsToInclude === null || teamsToInclude === void 0 ? void 0 : teamsToInclude.flat().length) > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(Box, {
          grow: true,
          shrink: true,
          children: /*#__PURE__*/_jsx(Text, {
            bold: true,
            as: "h3",
            overflow: "wrap",
            children: t('advanced_audience_widget_audience_colon')
          })
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(Button, {
            isActive: isAdvancedMode,
            size: "small",
            variant: "transparent",
            iconRight: "settings",
            onClick: onToggleAdvancedMode,
            children: t('advanced_audience_widget_advanced')
          })
        })]
      }), /*#__PURE__*/_jsx(AdvancedAudienceWidget, {
        disabled: disabled
        // Default to 'Everyone' if advanced mode is on and no teams are selected
        ,
        baseAudienceType: hasTeamsToIncludeSelected || !isAdvancedMode ? 'teams' : 'all',
        isAdvancedMode: isAdvancedMode,
        includedTeamGroups: teamsToInclude,
        excludedTeams: teamsToExclude,
        onRequestSelectTeams: function onRequestSelectTeams(teamGroup) {
          return setTeamGroupIndex(teamGroup);
        },
        onRemoveTeam: removeTeamFromGroup
      })]
    }), showTeamSelectorModal && /*#__PURE__*/_jsx(TeamPickerModal, {
      defaultSelectedItems: initialTeamSelectorSelection,
      onClose: closeTeamSelector,
      disabledItems: disabledTeams,
      onSubmit: changeSelectedTeams
    }), showDisableAdvancedModal && /*#__PURE__*/_jsx(SimpleModal, {
      title: t('modal_disable_advanced_audience_title'),
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          children: t('modal_disable_advanced_audience_info')
        }), /*#__PURE__*/_jsx(Text, {
          children: t('modal_disable_advanced_audience_message')
        })]
      }),
      buttons: [{
        label: t('actions_keep'),
        onClick: function onClick() {
          return setShowDisableAdvancedModal(false);
        }
      }, {
        variant: 'important',
        label: t('actions_discard_audience'),
        onClick: function onClick() {
          return disableAdvancedMode();
        }
      }],
      onClose: function onClose() {
        return setShowDisableAdvancedModal(false);
      }
    })]
  });
}
export default ShareWithTeamsWidget;